import { WrapperWidget } from '@agentselly/ui';
import { useTranslate } from '@tolgee/react';
import { formatPhoneNumber } from '~/shared/formatPhoneNumber';
import { Mail, Phone } from 'lucide-react';

interface Props {
  readonly internalAgent?: any;
  readonly externalAgent?: any;
  readonly link: string;
}

export function CockpitMarketingWidget(props: Props) {
  const { t } = useTranslate();

  return (
    <WrapperWidget>
      <div className="h-full flex flex-col gap-y-6">
        <h2 className="text-lg font-bold">
          {t('cockpit_marketing_widget_title')}
        </h2>
        <div className="flex flex-wrap gap-3">
          {props.internalAgent ? (
            <div className="flex items-start gap-3">
              {(props.internalAgent.photoUrl ||
                props.internalAgent.portraitImageUrl) && (
                <img
                  src={
                    (props.internalAgent.photoUrl ||
                      props.internalAgent.portraitImageUrl) as string
                  }
                  alt={`${props.internalAgent.firstname} ${props.internalAgent.lastname}`}
                  className="rounded-full w-16 h-16 object-cover"
                />
              )}
              <div>
                <h3 className="text-base md:text-lg font-semibold">
                  {t('cockpit_marketing_widget_marketing_title')}
                </h3>
                <div className="text-base md:text-lg font-semibold">
                  {props.internalAgent.firstname || 'Kein'}{' '}
                  {props.internalAgent.lastname || 'Berater'}
                </div>
                <div className="mt-1 flex items-center gap-2 text-sm md:text-base text-gray-700 dark:text-gray-200 dark:text-gray-300">
                  <Mail
                    size={16}
                    className="text-gray-500 dark:text-gray-400"
                  />
                  <a
                    href={`mailto:${props.internalAgent.email}`}
                    className="hover:underline"
                  >
                    {props.internalAgent.email}
                  </a>
                </div>
                <div className="mt-1 flex items-center gap-2 text-sm md:text-base text-gray-700 dark:text-gray-200 dark:text-gray-300">
                  <Phone
                    size={16}
                    className="text-gray-500 dark:text-gray-400"
                  />
                  <a
                    href={`tel:${props.internalAgent.phone}`}
                    className="hover:underline"
                  >
                    {formatPhoneNumber(props.internalAgent.phone)}
                  </a>
                </div>
                {props.internalAgent?.mobile && (
                  <div className="mt-1 flex items-center gap-2 text-sm md:text-base text-gray-700 dark:text-gray-200 dark:text-gray-300">
                    <Phone
                      size={16}
                      className="text-gray-500 dark:text-gray-400"
                    />
                    <a
                      href={`tel:${props.internalAgent.mobile}`}
                      className="hover:underline"
                    >
                      {formatPhoneNumber(props.internalAgent.mobile)}
                    </a>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="p-4 border dark:border-gray-700 rounded-lg">
              <h3 className="text-base md:text-lg font-semibold">
                Interner Berater
              </h3>
              <div className="text-sm text-gray-500 dark:text-gray-400">
                Noch keinen internen Berater zugewiesen
              </div>
            </div>
          )}
          {props.externalAgent ? (
            <div className="flex items-start gap-3">
              {(props.externalAgent.photoUrl ||
                props.externalAgent.portraitImageUrl) && (
                <img
                  src={
                    (props.externalAgent.photoUrl ||
                      props.externalAgent.portraitImageUrl) as string
                  }
                  alt={`${props.externalAgent.firstname} ${props.externalAgent.lastname}`}
                  className="rounded-full w-16 h-16 object-cover"
                />
              )}
              <div>
                <h3 className="text-base md:text-lg font-semibold">
                  {t('cockpit_marketing_widget_financing_title')}
                </h3>
                <div className="text-base md:text-lg font-semibold">
                  {props.externalAgent.firstname || 'Kein'}{' '}
                  {props.externalAgent.lastname || 'Berater'}
                </div>
                <div className="mt-1 flex items-center gap-2 text-sm md:text-base text-gray-700 dark:text-gray-200 dark:text-gray-300">
                  <Mail
                    size={16}
                    className="text-gray-500 dark:text-gray-400"
                  />
                  <a
                    href={`mailto:${props.externalAgent.email}`}
                    className="hover:underline"
                  >
                    {props.externalAgent.email}
                  </a>
                </div>
                <div className="mt-1 flex items-center gap-2 text-sm md:text-base text-gray-700 dark:text-gray-200 dark:text-gray-300">
                  <Phone
                    size={16}
                    className="text-gray-500 dark:text-gray-400"
                  />
                  <a
                    href={`tel:${props.externalAgent.phone}`}
                    className="hover:underline"
                  >
                    {formatPhoneNumber(props.externalAgent.phone)}
                  </a>
                </div>
                {props.externalAgent?.mobile && (
                  <div className="mt-1 flex items-center gap-2 text-sm md:text-base text-gray-700 dark:text-gray-200 dark:text-gray-300">
                    <Phone
                      size={16}
                      className="text-gray-500 dark:text-gray-400"
                    />
                    <a
                      href={`tel:${props.externalAgent.mobile}`}
                      className="hover:underline"
                    >
                      {formatPhoneNumber(props.externalAgent.mobile)}
                    </a>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="p-4 border dark:border-gray-700 rounded-lg">
              <h3 className="text-base md:text-lg font-semibold">
                Externer Berater
              </h3>
              <div className="text-sm text-gray-500 dark:text-gray-400">
                Noch keinen externen Berater zugewiesen
              </div>
            </div>
          )}
        </div>
      </div>
    </WrapperWidget>
  );
}
